import { useState } from 'react';
import {
  Popover,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverHeader,
  PopoverBody,
  Flex,
  Switch,
  Box,
  Text,
} from '@chakra-ui/react';
import analytics from '../../../../segmentTracking';

const FilterConfigPanel = ({
  isOpen,
  onClose,
  visibleFilters,
  setVisibleFilters,
  currentUser,
}) => {
  // Function to toggle filter visibility
  const toggleFilterVisibility = (filterType) => {
    setVisibleFilters((prev) => ({
      ...prev,
      [filterType]: !prev[filterType],
    }));

    // Track filter visibility change
    analytics.track('people:filterconfig:toggled', {
      email: currentUser?.email,
      userRole: currentUser?.role,
      filter: filterType,
      enabled: !visibleFilters[filterType],
    });
  };

  // Get filter options based on user role
  const getFilterOptions = () => {
    const baseFilters = [
      { key: 'schools', label: 'Schools' },
      { key: 'courses', label: 'Courses' },
    ];

    // Add instructors filter only for non-instructor roles
    if (currentUser?.role?.toLowerCase() !== 'instructor') {
      baseFilters.push({ key: 'instructors', label: 'Instructors' });
    }

    return baseFilters;
  };

  const filterOptions = getFilterOptions();

  return (
    <Popover isOpen={isOpen} onClose={onClose} placement="left-start">
      <PopoverContent
        width="217px"
        position="absolute"
        right="calc(0% + -50px)"
        top="50px"
        borderColor="#EF6506"
        borderWidth="1px"
        boxShadow="lg"
        bg="white"
        zIndex={1001}
      >
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverHeader fontSize="14px" fontWeight="500" color="#222222">
          Filter options
        </PopoverHeader>
        <PopoverBody py={3}>
          <Flex justifyContent="space-between" alignItems="center" mb={3}>
            <Text fontSize="12px" fontWeight="500" color="#676666">
              FILTERS
            </Text>
            <Text fontSize="12px" fontWeight="500" color="#676666">
              HIDE/SHOW
            </Text>
          </Flex>

          {filterOptions.map((filter) => (
            <Box
              key={filter.key}
              display="flex"
              alignItems="center"
              mb={3}
              justifyContent="space-between"
            >
              <Text fontSize="14px" fontWeight="400" color="#222222">
                {filter.label}
              </Text>
              <Switch
                id={filter.key}
                isChecked={visibleFilters[filter.key]}
                onChange={() => toggleFilterVisibility(filter.key)}
                size="sm"
                sx={{
                  '& .chakra-switch__track': {
                    backgroundColor: '#C2C2C2',
                  },
                  '& .chakra-switch__track[data-checked]': {
                    backgroundColor: '#EF6506',
                  },
                }}
              />
            </Box>
          ))}

          {filterOptions.length === 0 && (
            <Text fontSize="14px" color="gray.500" textAlign="center" py={2}>
              No filter options available
            </Text>
          )}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default FilterConfigPanel;
